import type { BaseEntity, SimpleTableConfig } from "../types";
import type { FieldLayout } from "../HorizontalCardView/types";

/**
 * Same field selection as desktop `HorizontalCardView` / `useCardFields`:
 * `showOnCard` + `cardFaceFieldOrder`, else first visible table columns (non–form-only).
 */
export function resolveCardFaceFieldLayout<T extends BaseEntity>(
  config: SimpleTableConfig<T>,
  visibleColumnIds: string[]
): FieldLayout {
  const fields = config.fields;
  const explicitCardIds = Object.keys(fields).filter((id) => fields[id]?.showOnCard === true);

  let orderedCardIds: string[];
  const order = config.cardFaceFieldOrder;
  if (order?.length) {
    const prioritized = order.filter((id) => explicitCardIds.includes(id));
    const remainder = explicitCardIds.filter((id: string) => !order.includes(id));
    orderedCardIds = [...prioritized, ...remainder];
  } else {
    orderedCardIds = explicitCardIds;
  }

  if (orderedCardIds.length > 0) {
    return {
      primaryField: orderedCardIds[0],
      secondaryField: orderedCardIds[1],
      contentFields: orderedCardIds.slice(2),
    };
  }

  const visibleFieldIds = visibleColumnIds.filter((id) => {
    const f = fields[id];
    return f && !f.formOnly;
  });

  return {
    primaryField: visibleFieldIds[0],
    secondaryField: visibleFieldIds[1],
    contentFields: visibleFieldIds.slice(2),
  };
}
